import { render, staticRenderFns } from "./NotesWithUrl.vue?vue&type=template&id=3b63e71b&scoped=true"
import script from "./NotesWithUrl.vue?vue&type=script&lang=js"
export * from "./NotesWithUrl.vue?vue&type=script&lang=js"
import style0 from "./NotesWithUrl.vue?vue&type=style&index=0&id=3b63e71b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b63e71b",
  null
  
)

export default component.exports